var map = {
	"./": 8305,
	"./App": 9555,
	"./App.js": 9555,
	"./App.test": 754,
	"./App.test.js": 754,
	"./assets/images/apple-day1.avif": 1419,
	"./assets/images/banana-day1-scaled.avif": 1751,
	"./assets/images/magoes.webp": 999,
	"./assets/images/smallit.jpeg": 4780,
	"./components": 9930,
	"./components/": 9930,
	"./components/Cart/CarItem": 6995,
	"./components/Cart/CarItem.js": 6995,
	"./components/Cart/CartList": 8362,
	"./components/Cart/CartList.js": 8362,
	"./components/Counter": 837,
	"./components/Counter/": 837,
	"./components/Counter/Decrement": 47,
	"./components/Counter/Decrement.js": 47,
	"./components/Counter/Increment": 5510,
	"./components/Counter/Increment.js": 5510,
	"./components/Counter/index": 837,
	"./components/Counter/index.js": 837,
	"./components/Item": 6319,
	"./components/Item/": 6319,
	"./components/Item/ItemCard": 3840,
	"./components/Item/ItemCard.js": 3840,
	"./components/Item/ItemsList": 4372,
	"./components/Item/ItemsList.js": 4372,
	"./components/Item/SearchItem": 6228,
	"./components/Item/SearchItem.js": 6228,
	"./components/Item/index": 6319,
	"./components/Item/index.js": 6319,
	"./components/NoItems": 5623,
	"./components/NoItems/": 5623,
	"./components/NoItems/index": 5623,
	"./components/NoItems/index.js": 5623,
	"./components/common": 4129,
	"./components/common/": 4129,
	"./components/common/index": 4129,
	"./components/common/index.js": 4129,
	"./components/common/table/head": 1156,
	"./components/common/table/head.js": 1156,
	"./components/index": 9930,
	"./components/index.js": 9930,
	"./db/data": 9002,
	"./db/data-save": 7577,
	"./db/data-save.json": 7577,
	"./db/data.json": 9002,
	"./index": 8305,
	"./index.js": 8305,
	"./pages/CarPage": 3934,
	"./pages/CarPage.js": 3934,
	"./pages/ItemsPage": 6937,
	"./pages/ItemsPage.js": 6937,
	"./pages/layout/DefaultLayout": 1183,
	"./pages/layout/DefaultLayout.js": 1183,
	"./pages/layout/Navbar": 9622,
	"./pages/layout/Navbar.js": 9622,
	"./redux/actions/actionTypes": 6586,
	"./redux/actions/actionTypes.js": 6586,
	"./redux/actions/asyncActions/cartAsync": 2633,
	"./redux/actions/asyncActions/cartAsync.js": 2633,
	"./redux/actions/asyncActions/itemsAsync": 5246,
	"./redux/actions/asyncActions/itemsAsync.js": 5246,
	"./redux/actions/cartActions": 1449,
	"./redux/actions/cartActions.js": 1449,
	"./redux/actions/itemActions": 5359,
	"./redux/actions/itemActions.js": 5359,
	"./redux/reducers": 992,
	"./redux/reducers/": 992,
	"./redux/reducers/CartReducer": 8966,
	"./redux/reducers/CartReducer.js": 8966,
	"./redux/reducers/ItemsReducer": 4320,
	"./redux/reducers/ItemsReducer.js": 4320,
	"./redux/reducers/index": 992,
	"./redux/reducers/index.js": 992,
	"./redux/store": 2652,
	"./redux/store.js": 2652,
	"./routes": 3082,
	"./routes/": 3082,
	"./routes/index": 3082,
	"./routes/index.js": 3082,
	"./service/api": 2690,
	"./service/api.js": 2690,
	"./setupTests": 9511,
	"./setupTests.js": 9511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;